import { formatTimecode } from '../../../../../lib/media/timecode';

/** The "Note at" affordance on an AI finding — `Note at 0:03` — wherever the review offers one. */
export function noteAtLabel(tMs: number): string {
  return `Note at ${formatTimecode(tMs)}`;
}
